// Default Modal like a a small pop-up on the screen
export const DEFAULT = 0;
// Drawer Modal
export const DRAWER = 1;
// Has ancient css attached to it
export const LEGACY = 2;
